<template>
  <v-card class="mx-auto carddata h-100 property-card">
    <div class="card-image-wrapper" @click="singleAd(idcard)">
      <v-img 
        cover 
        height="250" 
        :src="imageUrl" 
        class="property-image"
        @error="handleImageError"
      >
        <template v-slot:placeholder>
          <div class="image-placeholder">
            <v-icon icon="mdi-image-off" size="48" color="grey-lighten-1"></v-icon>
          </div>
        </template>
        <template v-slot:error>
          <div class="image-placeholder">
            <v-icon icon="mdi-image-off" size="48" color="grey-lighten-1"></v-icon>
          </div>
        </template>
      </v-img>
      <div class="image-overlay"></div>
    </div>
    <div class="card-content-wrapper">
      <v-card-item class="card-header">
        <div class="price-type-row">
          <h3 class="property-price" @click="singleAd(idcard)">
            {{ title?.split('.')[0] }}
            <span class="currency">{{ $t("SR") }}</span>
          </h3>
          <span class="span-type" v-if="type">{{ type }}</span>
        </div>
        <p class="property-subtitle" v-if="subtitle">{{ subtitle }}</p>
      </v-card-item>
      <div class="card-info-section">
        <div class="location-info">
          <v-icon icon="mdi-map-marker-outline" class="location-icon"></v-icon>
          <span class="location-text">{{ city }}</span>
        </div>
        <div class="date-info">
          <v-icon icon="mdi-calendar-outline" class="date-icon"></v-icon>
          <span class="date-text">{{ date }}</span>
        </div>
      </div>
      <div class="property-features" v-if="numwidth && numwidth.length > 0">
        <div
          v-for="(item, i) in numwidth"
          :key="i"
          class="feature-item"
          v-if="item.show_outside == 1"
        >
          <div class="feature-content">
            <img :src="item.image" class="feature-icon" :alt="item.name" />
            <div class="feature-values">
              <span 
                v-for="(ele, idx) in item.values" 
                :key="idx"
                class="feature-value"
              >
                {{
                  typeof ele === 'object'
                    ? (ele[0] === "true" ? "نعم" : ele[0] === "false" ? "لا" : ele[0])
                    : ele
                }}
              </span>
            </div>
          </div>
        </div>
      </div>
      <v-card-actions class="card-footer">
        <button class="user-label-btn" @click="single(useritem.id)">
          <div class="user-label-content">
            <div class="avatar-wrapper">
              <img 
                v-if="useritem?.image" 
                :src="useritem.image" 
                alt="User" 
                class="user-avatar"
              />
              <v-icon v-else icon="mdi-account-circle" class="user-avatar-icon"></v-icon>
            </div>
            <span class="user-name">{{ useritem?.name || 'مستخدم' }}</span>
          </div>
        </button>
      </v-card-actions>
    </div>
  </v-card>
</template>

<script>
import crudDataService from '@/Services/crudDataService';

export default {
  data(){
    return{
      useritem:'',
      imageError: false,
    }
  },
  props: {
    image: {
      type: String,
      required: true,
    },
    title: {
      type: String,
    },
    subtitle: {
      type: String,
    },
    city: {
      type: String,
    },
    date: {
      type: String,
    },
    type: {
      type: String,
    },

    numwidth: {
      type: Array,
    },
    idcard: {
      type: Number,
    },
    userid:{
      type:Number
    },
    idsupport: {
      type: Number,
    },
    
  },
  computed: {
    imageUrl() {
     
      return this.image;
    }
  },
  methods: {
    handleImageError() {
      this.imageError = true;
    },
    async userprof(){
      let user=await crudDataService.get('user-profile',this.userid)
      console.log(user.data.data);
      this.useritem=user.data.data
    },
    singleAd(id) {
      this.$router.push({ name: "SingleAd", params: { id } });
    },
    single(id) {
      this.$router.push({ name: "SinglePartner", params: { id } });
    },
  },
  mounted(){
    this.userprof();
    // Reset image error when image prop changes
    this.imageError = false;
  },
  watch: {
    image() {
      // Reset error when image changes
      this.imageError = false;
    }
  }
};
</script>

<style scoped lang="scss">
.property-card {
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
  border: 1px solid #e5e7eb;
  padding: 0;
  
  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
    border-color: #fede2c;
  }
}

.card-image-wrapper {
  position: relative;
  overflow: hidden;
  cursor: pointer;
  background: #f3f4f6;
  min-height: 250px;
  
  .property-image {
    transition: transform 0.3s ease;
    background: #f3f4f6;
  }
  
  &:hover .property-image {
    transform: scale(1.05);
  }
  
  .image-overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(to bottom, transparent 0%, rgba(0, 0, 0, 0.1) 100%);
    pointer-events: none;
  }
  
  .image-placeholder {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 250px;
    background: #f3f4f6;
  }
}

.card-content-wrapper {
  padding: 16px;
}

.card-header {
  padding: 0 0 12px 0 !important;
  
  .price-type-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 8px;
    gap: 8px;
  }
  
  .property-price {
    font-size: 24px;
    font-weight: 700;
    color: #1f2937;
    margin: 0;
    cursor: pointer;
    transition: color 0.2s ease;
    
    &:hover {
      color: #0074c7;
    }
    
    .currency {
      font-size: 18px;
      font-weight: 500;
      color: #6b7280;
      margin-right: 4px;
    }
  }
  
  .property-subtitle {
    font-size: 16px;
    color: #4b5563;
    margin: 0;
    font-weight: 500;
  }
}

.span-type {
  background: linear-gradient(135deg, #fede2c 0%, #f6c712 100%);
  border-radius: 8px;
  padding: 6px 12px;
  font-size: 12px;
  font-weight: 600;
  color: #1f2937;
  white-space: nowrap;
  box-shadow: 0 2px 4px rgba(254, 222, 44, 0.3);
}

.card-info-section {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 12px 0;
  border-top: 1px solid #e5e7eb;
  border-bottom: 1px solid #e5e7eb;
  margin-bottom: 12px;
}

.location-info,
.date-info {
  display: flex;
  align-items: center;
  gap: 8px;
  
  .location-icon,
  .date-icon {
    color: #0074c7;
    font-size: 18px;
  }
  
  .location-text,
  .date-text {
    font-size: 14px;
    color: #6b7280;
    font-weight: 500;
  }
}

.property-features {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;
  margin-bottom: 12px;
}

.feature-item {
  .feature-content {
    display: flex;
    align-items: center;
    gap: 8px;
  }
  
  .feature-icon {
    width: 24px;
    height: 24px;
    object-fit: contain;
    flex-shrink: 0;
  }
  
  .feature-values {
    display: flex;
    flex-wrap: wrap;
    gap: 4px;
  }
  
  .feature-value {
    font-size: 13px;
    color: #4b5563;
    font-weight: 500;
  }
}

.card-footer {
  padding: 0 !important;
  margin-top: 8px;
}

.user-label-btn {
  width: 100%;
  padding: 10px 12px;
  background: transparent;
  border: 2px solid #fede2c;
  border-radius: 10px;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  
  &:hover {
    background: rgba(254, 222, 44, 0.1);
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(254, 222, 44, 0.3);
    border-color: #f6c712;
  }
  
  &:active {
    transform: translateY(0);
  }
}

.user-label-content {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  width: 100%;
}

.avatar-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
}

.user-avatar {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  object-fit: cover;
  border: 2px solid #fede2c;
  flex-shrink: 0;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.user-avatar-icon {
  font-size: 36px;
  color: #fede2c;
  flex-shrink: 0;
}

.user-name {
  font-size: 15px;
  font-weight: 600;
  color: #1f2937;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 150px;
}

@media (max-width: 600px) {
  .card-content-wrapper {
    padding: 12px;
  }
  
  .property-price {
    font-size: 20px !important;
    
    .currency {
      font-size: 16px !important;
    }
  }
  
  .property-subtitle {
    font-size: 14px !important;
  }
  
  .user-name {
    font-size: 13px;
    max-width: 120px;
  }
  
  .user-avatar {
    width: 32px;
    height: 32px;
  }
  
  .user-avatar-icon {
    font-size: 32px;
  }
  
  .property-features {
    gap: 8px;
  }
  
  .feature-icon {
    width: 20px;
    height: 20px;
  }
  
  .feature-value {
    font-size: 12px;
  }
}
</style>
